import { Polygon, MultiPolygon } from 'geojson';
import { apiCall } from '@/utils/api';

export const getSegmentsFromPolygon = async (
  polygon: Polygon | MultiPolygon,
  filters: string[] = [],
) => {
  try {
    const response = await apiCall(
      `${process.env.NEXT_PUBLIC_API}/segments/find`,
      {
        method: 'POST',
      },
      { geometry: polygon, filters },
    );
    return response;
  } catch (error: any) {
    return { error };
  }
};

export const getNumTimesMapped = async (geometry: GeoJSON.Geometry) => {
  try {
    const response = await apiCall(
      `${process.env.NEXT_PUBLIC_API}/segments/numTimesMapped`,
      { method: 'POST' },
      { geometry: geometry },
    );
    return response;
  } catch (error) {
    return { error };
  }
};

export const getSegmentById = async (id: string) => {
  const url = `${process.env.NEXT_PUBLIC_API}/segments/segment/${id}`;
  try {
    const response = await apiCall(url, { method: 'GET' });
    return response;
  } catch (error: any) {
    console.log(error);
    return { error };
  }
};

export const getMapFeaturesAttachedToSegment = async (segmentId: string) => {
  const url = `${process.env.NEXT_PUBLIC_API}/segments/mapfeaturesinsegment/${segmentId}`;
  try {
    const mapFeatures = await apiCall(url, { method: 'GET' });
    return mapFeatures;
  } catch (error: any) {
    console.log(error);
    return { error };
  }
};
